import { useEffect, useRef } from 'react';

const BackgroundPattern = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');


    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      centerX = canvas.width / 2;
      centerY = canvas.height / 2;
    };

    let centerX = 0;
    let centerY = 0;
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Space stars data
    const stars = [];
    const starCount = 200;

    // Star colors for space effect
    const starColors = [
      '#ffffff', 
      '#e0f2ff', 
      '#f0f8ff',
      '#e6e6fa',
      '#f8f8ff', 
      '#b0e0e6', 
    ];

    for (let i = 0; i < starCount; i++) {
      stars.push({
        x: (Math.random() - 0.5) * 2000,
        y: (Math.random() - 0.5) * 2000,
        z: Math.random() * 1000 + 1,
        color: starColors[Math.floor(Math.random() * starColors.length)],
        opacity: Math.random() * 0.8 + 0.2,
        twinkle: Math.random() * Math.PI * 2,
        twinkleSpeed: Math.random() * 0.02 + 0.01,
        size: Math.random() * 2 + 0.5,
      });
    }


    const shootingStars = [];
    const maxShootingStars = 3;

    const createShootingStar = () => {
      if (shootingStars.length < maxShootingStars && Math.random() < 0.003) {
        shootingStars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height * 0.5,
          length: Math.random() * 80 + 20,
          speed: Math.random() * 6 + 4,
          angle: Math.random() * Math.PI / 4 + Math.PI / 4,
          opacity: 1,
          decay: Math.random() * 0.02 + 0.01,
        });
      }
    };

    const animate = () => {
      const gradient = ctx.createRadialGradient(
        centerX, centerY, 0,
        centerX, centerY, Math.max(canvas.width, canvas.height)
      );
      gradient.addColorStop(0, '#0a0a1a');
      gradient.addColorStop(0.3, '#1a1a2e');
      gradient.addColorStop(0.6, '#16213e');
      gradient.addColorStop(1, '#0f0f1a');

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      stars.forEach((star) => {
        star.z -= 2;

        if (star.z <= 0) {
          star.x = (Math.random() - 0.5) * 2000;
          star.y = (Math.random() - 0.5) * 2000;
          star.z = 1000;
        }

        const screenX = (star.x / star.z) * 300 + centerX;
        const screenY = (star.y / star.z) * 300 + centerY;


        if (screenX < 0 || screenX > canvas.width || screenY < 0 || screenY > canvas.height) {
          return;
        }

        const size = (1 - star.z / 1000) * star.size * 3;

        star.twinkle += star.twinkleSpeed;
        const twinkleOpacity = star.opacity * (0.8 + 0.2 * Math.sin(star.twinkle));

       
        ctx.save();
        ctx.globalAlpha = twinkleOpacity;
        ctx.fillStyle = star.color;

        ctx.shadowColor = star.color;
        ctx.shadowBlur = size * 2;

        ctx.beginPath();
        ctx.arc(screenX, screenY, size, 0, Math.PI * 2);
        ctx.fill();

     
        if (size > 1.5) {
          ctx.shadowBlur = 0;
          ctx.strokeStyle = star.color;
          ctx.lineWidth = 0.5;

         
          ctx.beginPath();
          ctx.moveTo(screenX, screenY - size * 2);
          ctx.lineTo(screenX, screenY + size * 2);
          ctx.stroke();

          
          ctx.beginPath();
          ctx.moveTo(screenX - size * 2, screenY);
          ctx.lineTo(screenX + size * 2, screenY);
          ctx.stroke();
        }

        ctx.restore();
      });

      createShootingStar();

      shootingStars.forEach((shootingStar, index) => {
        const dx = Math.cos(shootingStar.angle) * shootingStar.speed;
        const dy = Math.sin(shootingStar.angle) * shootingStar.speed;

        shootingStar.x += dx;
        shootingStar.y += dy;
        shootingStar.opacity -= shootingStar.decay;

        ctx.save();
        ctx.globalAlpha = shootingStar.opacity;

        const gradient = ctx.createLinearGradient(
          shootingStar.x, shootingStar.y,
          shootingStar.x - dx * shootingStar.length / shootingStar.speed,
          shootingStar.y - dy * shootingStar.length / shootingStar.speed
        );
        gradient.addColorStop(0, '#ffffff');
        gradient.addColorStop(0.6, '#e0f2ff');
        gradient.addColorStop(1, 'transparent');

        ctx.strokeStyle = gradient;
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';

        ctx.beginPath();
        ctx.moveTo(shootingStar.x, shootingStar.y);
        ctx.lineTo(
          shootingStar.x - dx * shootingStar.length / shootingStar.speed,
          shootingStar.y - dy * shootingStar.length / shootingStar.speed
        );
        ctx.stroke();

        ctx.restore();

        if (shootingStar.opacity <= 0 ||
            shootingStar.x < 0 || shootingStar.x > canvas.width ||
            shootingStar.y < 0 || shootingStar.y > canvas.height) {
          shootingStars.splice(index, 1);
        }
      });

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-0"
      style={{ background: 'transparent' }}
    />
  );
};

export default BackgroundPattern;
